export default "__VITE_ASSET__B7hbaMVn__"